<template>
  <div
    class="flow-card"
    :class="[
      {'flow-card--selected': selected},
      {'flow-card--disabled': card.disabled},
      `flow-card--${color}`,
      card.itemClass,
    ]"
  >
    <i :class="card.iconClass" class="flow-card__icon" aria-hidden="true"></i>
    <h4 class="flow-card__title">{{ card.name }}</h4>
    <p class="flow-card__description">
      {{ card.description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'flow-card',
  props: {
    card: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'green',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-card {
  background: #fff;
  border: 1px solid $platinum-color;
  border-radius: 4px;
  width: 280px;
  height: 208px;
  padding: 24px;
  transition: all 0.2 ease-in;
  cursor: pointer;
  &__description {
    color: $dove-grey-color;
    margin: 0;
  }
  &__icon {
    font-size: 48px;
    margin-bottom: 26px;
  }
  &--selected {
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.16);
  }
  &--green &__icon {
    color: $half-baked-color;
  }
  &--green.flow-card--selected {
    background: $half-baked-color;
    border-color: $half-baked-color;
    & > * {
      color: #fff;
    }
  }
  &--disabled {
    background: $grey-cloud-color;
    pointer-events: none;
    & > * {
      color: #6e6e6e !important;
    }
  }
}
</style>
